export default __webpack_public_path__ + "static/media/Black Wall-mini.08e05959.jpg";